<ubs-payment-statuses [orderId]="orderId"></ubs-payment-statuses>
<ubs-exteral-payments [orderId]="orderId"></ubs-exteral-payments>
<ubs-billing-accounts [orderId]="orderId"></ubs-billing-accounts>
<ubs-credit-card [orderId]="orderId"></ubs-credit-card>
<ubs-eft-payments [orderId]="orderId"></ubs-eft-payments>
<ubs-financial-accounts [orderId]="orderId"></ubs-financial-accounts>
<ubs-gift-card [orderId]="orderId"></ubs-gift-card>
<!-- <ubs-offline-payments [orderId]="orderId"></ubs-offline-payments> -->
